import React, { RefObject } from 'react';
import { RFQ } from '../../types';
import { JourneyReadiness } from '../../utils/journeyReadiness';
import { StageReport } from '../../utils/stageActivity';
import UploadDocuments, { UploadDocumentsHandle } from '../../components/forms/UploadDocuments';
import CriteriaStep from '../../components/forms/criteria/CriteriaStep';
import BOMAnalysis from '../../components/forms/BOMAnalysis';
import SupplierOutreach from '../../components/forms/SupplierOutreach';
import QuotesProposals from '../../components/forms/QuotesProposals';
import type { useWizardRobbie } from './useWizardRobbie';

interface WizardStepContentProps {
  step: number;
  rfq: RFQ;
  readiness: JourneyReadiness;
  uploadDocsRef: RefObject<UploadDocumentsHandle | null>;
  sendToRobbie: ReturnType<typeof useWizardRobbie>['sendToRobbie'];
  onNext: () => void;
  onBack: () => void;
  onCancel: () => void;
  onWorking: (stage: StageReport | null) => void;
}

/** The workspace for the step on screen. */
const WizardStepContent: React.FC<WizardStepContentProps> = ({
  step, rfq, readiness, uploadDocsRef, sendToRobbie, onNext, onBack, onCancel, onWorking,
}) => {
  switch (step) {
    case 1:
      return (
        <UploadDocuments ref={uploadDocsRef} rfq={rfq} onNext={onNext} onCancel={onCancel} onWorking={onWorking} />
      );
    case 2:
      return (
        <CriteriaStep
          rfq={rfq}
          onNext={onNext}
          onBack={onBack}
          sendToRobbie={sendToRobbie}
          onWorking={onWorking}
        />
      );
    case 3:
      return (
        <BOMAnalysis
          rfq={rfq}
          onNext={onNext}
          onPrevious={onBack}
          onAskRobbie={sendToRobbie}
          onWorking={onWorking}
        />
      );
    case 4:
      return (
        <SupplierOutreach
          rfq={rfq}
          onNext={onNext}
          onBack={onBack}
          continueDisabledReason={readiness.stepDone[4] ? undefined : readiness.stepReason[4]}
        />
      );
    case 5:
      return <QuotesProposals rfq={rfq} onBack={onBack} onWorking={onWorking} />;
    default:
      return <div className="py-12 text-center text-body-md text-ink-muted">This step is currently locked.</div>;
  }
};

export default WizardStepContent;
